import CommonHelmet from '@src/components/CommonHelmet';
import PasswordEdit from '@src/features/company/auth/PasswordEdit';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyPasswordEdit() {
  return (
    <>
      <CompanyCenterCardLayout>
        <CommonHelmet />
        <PasswordEdit />
      </CompanyCenterCardLayout>
    </>
  );
}

export default CompanyPasswordEdit;
